module.exports = "<div class=\"errormsg\">\n    <div *ngIf=\"errorMessage !== null\">{{errorMessage}}</div>\n</div>"